import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "py-2 px-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "transport_date",
  class: "block text-sm font-medium leading-6 text-secondary"
}, "Dato", -1)
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = ["label"]
const _hoisted_5 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("select", {
        id: "combobox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedDate) = $event)),
        class: "peer block w-full rounded-md border-0 pb-1.5 pt-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-200 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 font-medium",
        role: "combobox",
        "aria-controls": "options",
        "aria-expanded": "false"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateOptions, (dates, week) => {
          return (_openBlock(), _createElementBlock("optgroup", {
            label: week,
            key: week
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dates, (date) => {
              return (_openBlock(), _createElementBlock("option", {
                key: date.formatted,
                value: date.formatted
              }, _toDisplayString(date.formatted), 9, _hoisted_5))
            }), 128))
          ], 8, _hoisted_4))
        }), 128))
      ], 512), [
        [_vModelSelect, _ctx.selectedDate]
      ])
    ])
  ]))
}